<div class="hero min-h-80" style="background-image: url('assets/images/banner/banner-sub-page.jpeg');">
  <div class="hero-overlay bg-opacity-60"></div>
  <div class="hero-content text-center text-neutral-content">
    <div class="max-w-2xl">
      <h1 class="mb-3 text-5xl font-bold">Latest Events</h1>
    </div>
  </div>
</div>
<div class="container px-5 mx-auto">
  <section class="py-10">
    <ng-container *ngIf="isLoading; else content">
      <div class="grid grid-cols-1 gap-4 pt-5 pb-9">
        <div class="event-list cursor-pointer">
          <div class="flex flex-row gap-2 border flex-wrap lg:flex-nowrap [&>.skeleton]:rounded-none"
            [ngClass]="currentTheme === 'dark' ? 'border-slate-600' : 'border-slate-200'">
            <div class="skeleton h-[220px] lg:h-[250px] w-full lg:w-3/12"></div>
            <div class="px-2 py-2 flex w-full flex-col gap-2">
              <div class="skeleton h-4 w-12"></div>
              <div class="skeleton h-4 w-9/12"></div>
              <div class="skeleton h-4 w-8/12"></div>
              <div class="skeleton h-4 w-20"></div>
              <div class="skeleton h-[100px] w-[98%]"></div>
              <div class="skeleton h-4 w-16"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #content>
      <div class="grid grid-rows-1 gap-6">
        <div (click)="routClick(event.id)"
          class="event-list border grid grid-cols-1 lg:grid-cols-[27%_73%] w-full gap-4  cursor-pointer relative"
          [ngClass]="currentTheme === 'dark' ? 'border-slate-600' : 'border-slate-200'"
          *ngFor="let event of latestEventData">
          <div class="relative w-full">
            <img class="w-full" [src]="event?.banner_image" (error)="onError($event)" alt="{{event?.title}}">
          </div>
          <div class="p-3">
            <div *ngIf="event?.status === 'up_coming'" class=" badge text-[10px] mb-2 uppercase rounded shadow-md"
              [ngClass]="{ 'bg-gradient-to-r from-pink-500 to-red-600 border-[#ff0a4c] text-slate-50': event?.status === 'up_coming'}">
              Upcoming
            </div>
            <div
              class="badge text-[10px] uppercase rounded bg-[#d80a0a] border-[#d80a0a] shadow-md text-slate-50"
              *ngIf="event.status === 'ongoing'"><img class="w-4 rotate" src="assets/images/live-icon.png" alt="">
              <span class="ml-1">LIVE</span>
            </div>
            <h3 class="text-2xl">{{event?.title}}</h3>
            <span [ngClass]="currentTheme === 'dark' ? 'bg-slate-800' : 'bg-gray-200'"
              class="text-xs inline-block p-1  my-3 rounded-sm">On:
              {{event?.start_time | date:'EEE dd MMM, yyyy hh:mm a'}}</span>
            <ng-container *ngIf="event?.speakers && event.speakers.length > 0">
              <div class="speaker text-sm" *ngFor="let speaker of event.speakers">
                <span class="font-semibold capitalize" *ngIf="speaker?.name">{{speaker?.name}}</span>
                <span class="capitalize" *ngIf="speaker?.job_title"> - {{speaker?.job_title}}</span>
              </div>
            </ng-container>
            <p class="mt-3 [&>strong]:block [&>strong]:my-2" *ngIf="event?.description"
              [innerHTML]="event.description.length > 270 ? (event.description | slice: 0:270) + '...' : event.description">
            </p>
            <div class="mt-3">
              <a><span class="mkdf-btn-text uppercase readmore font-semibold mt-4">Read More</span></a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </section>
</div>
